'use es6';

import tinymce from 'tinymce';
import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { jsx as _jsx } from "react/jsx-runtime";
let popoverId = 0;
tinymce.canvas = {
  addPopover(editor, name, config) {
    if (!editor.popovers) {
      editor.popovers = {};
    }
    editor.popovers[name] = config;
  },
  addToolbarPopover(editor, name, config) {
    if (!editor.toolbarPopovers) {
      editor.toolbarPopovers = {};
    }
    editor.toolbarPopovers[name] = config;
  },
  addNodeChangeHandler(editor, config) {
    if (!editor.nodeChangeHandlers) {
      editor.nodeChangeHandlers = [];
    }
    editor.nodeChangeHandlers.push(config);
  },
  addButton(editor, name, config) {
    if (!editor.buttons) {
      editor.buttons = {};
    }
    editor.buttons[name] = config;
  },
  addMenuItem(editor, name, config) {
    if (!editor.menuItems) {
      editor.menuItems = {};
    }
    editor.menuItems[name] = config;
  },
  addIdleCallback(editor, selector, callback) {
    if (!editor.idleCallbackQueue) {
      editor.idleCallbackQueue = [];
    }
    editor.idleCallbackQueue.push({
      selector,
      callback
    });
  },
  /*
    type Command = {
      label: i18n.text;
      id: string,
      onSelect: () => void
    }
    config = {
      trigger,
      getFilteredCommands: (inputText: string) => Command[],
    }
  */
  addAutocompleteCommand(editor, config) {
    if (!editor.autoCompleteCommands) {
      editor.autoCompleteCommands = {};
    }
    if (!editor.autoCompleteCommands[config.trigger]) {
      editor.autoCompleteCommands[config.trigger] = [config.getFilteredCommands];
    } else {
      editor.autoCompleteCommands[config.trigger].push(config.getFilteredCommands);
    }
  },
  addAutocompleteQuickInsertOption(editor, config) {
    if (!editor.autocompleteQuickInsertOptions) {
      editor.autocompleteQuickInsertOptions = {};
    }
    if (!editor.autocompleteQuickInsertOptions[config.trigger]) {
      editor.autocompleteQuickInsertOptions[config.trigger] = [config.getFilteredCommands];
    } else {
      editor.autocompleteQuickInsertOptions[config.trigger].push(config.getFilteredCommands);
    }
  }
};
export const renderPopovers = editor => {
  if (!editor.popovers) {
    return;
  }
  const popoverContainer = document.createElement('div');
  popoverContainer.dataset.testId = `${editor.id}__popover-container`;
  popoverContainer.id = `${editor.id}__popover-container`;
  document.body.appendChild(popoverContainer);
  ReactDOM.render( /*#__PURE__*/_jsx(Fragment, {
    children: Object.keys(editor.popovers).map(popover => editor.popovers[popover].renderPopover({
      key: `mce-hubspot-popover-${++popoverId}`
    }))
  }), popoverContainer);
  editor.on('remove', () => {
    ReactDOM.unmountComponentAtNode(popoverContainer);
  });
};
export const handleMinHeight = editor => {
  const target = editor.settings.target;
  if (!target) {
    return;
  }
  target.style.setProperty('min-height', editor.settings.min_height, 'important');
};

/*
  This allows us to perform a check to see if plugins are utilized on editor
  init and if so immediately fetch the data for those plugins. Otherwise we
  can delay those callbacks to idle browser time since they aren't immediately
  needed to initialize the editor.
*/
export const registerIdleCallbacks = editor => {
  editor.on('init', () => {
    const body = editor.getBody();
    if (!editor.idleCallbackQueue) {
      return;
    }
    editor.idleCallbackQueue.forEach(({
      selector,
      callback
    }) => {
      if (body.querySelector(selector)) {
        callback();
      } else {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(callback, {
            timeout: 4000
          });
        } else {
          tinymce.util.Delay.setEditorTimeout(editor, callback, 4000);
        }
      }
    });
  });
};